const themeOverrides = {
  token: {
    colorPrimary: "#273E52",
  },
  components: {
    Button: {
      // colorPrimary: "#273E52",
    },
  },
}

export default themeOverrides;